import { makeThumbnail } from './thumbnails';

export const IDENTIFY_MAX_DIM = 2400;
export const IDENTIFY_QUALITY = 0.85;

export const shrinkForIdentify = (bytes: Blob) =>
  makeThumbnail(bytes, { maxDim: IDENTIFY_MAX_DIM, quality: IDENTIFY_QUALITY });

// Shrunk at capture, by photo id, so identifying a photo this tab took skips downloading and
// decoding its original. Lost on reload, when the runner falls back to the download.
const MAX_IMAGES = 30;
const images = new Map<string, Promise<Blob>>();
// One shrink at a time: a burst of shots would otherwise decode several originals at once.
let last: Promise<unknown> = Promise.resolve();

export function cacheIdentifyImage(photoId: string, bytes: Blob, shrink = shrinkForIdentify): void {
  const image = last.then(() => shrink(bytes));
  last = image.catch(() => {});
  images.set(photoId, image);
  image.catch(() => {
    if (images.get(photoId) === image) images.delete(photoId);
  });
  const [oldest] = images.keys();
  if (images.size > MAX_IMAGES && oldest !== undefined) images.delete(oldest);
}

/** The image shrunk at capture, or undefined when there is none or its shrink failed. */
export async function cachedIdentifyImage(photoId: string): Promise<Blob | undefined> {
  return images.get(photoId)?.catch(() => undefined);
}
